import { memo } from "react";

import InteractiveColumn, {
  TableHeadInteractiveColumnProps,
} from "ds/components/Table/Head/InteractiveColumn";
import { TableColumnMeta } from "ds/components/Table/types";

import { TableSimpleStore } from "./types";

type TableSimpleHeadColumnProps = {
  column: TableColumnMeta;
  store: TableSimpleStore;
} & Pick<
  TableHeadInteractiveColumnProps,
  | "stickyLeft"
  | "stickyRight"
  | "children"
  | "tableRef"
  | "analyticsPage"
  | "filtersStorageKey"
  | "sortCallback"
  | "sortConfig"
>;

const TableSimpleHeadColumn = ({
  column,
  store,
  stickyLeft,
  stickyRight,
  children,
  tableRef,
  analyticsPage,
  filtersStorageKey,
  sortCallback,
  sortConfig,
}: TableSimpleHeadColumnProps) => {
  return (
    <InteractiveColumn
      column={column}
      store={store}
      stickyLeft={stickyLeft}
      stickyRight={stickyRight}
      analyticsPage={analyticsPage}
      filtersStorageKey={filtersStorageKey}
      tableRef={tableRef}
      sortCallback={sortCallback}
      sortConfig={sortConfig}
    >
      {children}
    </InteractiveColumn>
  );
};

TableSimpleHeadColumn.displayName = "DS.TableSimple.HeadColumn";

export default memo(TableSimpleHeadColumn) as typeof TableSimpleHeadColumn;
